import type { StripeAuthConnectRequestPayload } from '@vy/api-definition';
import type { UseMutationOptions } from 'react-query';
import { useMutation } from 'react-query';
import { getPrivateApi } from '../../services/api';

export function useStripeConnect(
  options?: UseMutationOptions<void, unknown, StripeAuthConnectRequestPayload>,
) {
  return useMutation((stripeConnectRequest) => {
    const api = getPrivateApi();

    return api.stripeConnect({ stripeConnectRequest });
  }, options);
}
